// extracted by mini-css-extract-plugin
export default {"button":"play-button_button__WaQhY","button--center":"play-button_button--center__ymh3y","icon":"play-button_icon__sd1+V"};